export enum VariationType {
  CONTENT_PIECE = 'content-piece',
  TIP = 'tip',
}
